"use strict";

// Global constants

var dbPlans;
var couponObject;
var couponPlanIds;

const initCheckout = () => {

  // to add blue background when item is selected
  const radioHolderSelector = ".list-group-item";
  const form = $("#checkout-container");

  // Form Fields
  const planTypeInputs = form.find("[name=plan_type]");
  const planInputs = form.find("[name=plan_id]");
  const oldPriceContainer = form.find("#resumeOldPrice");
  const newPriceContainer = form.find("#resumeNewPrice");
  const memberSliderHolder = form.find("#member-slider-holder");
  const memberCountInput = form.find('[name="n_members"]');
  const sliderElement = form.find("#slider");
  const memberCountLabelElement = form.find("#n-members-readonly");
  const maxMemberLabelElements = form.find("[data-max-member]");
  const currentUnitPriceElements = form.find("[data-show-unit-price]");
  const currentPriceElements = form.find("[data-show-current-price]");
  const currentFullPriceElements = form.find("[data-show-current-full-price]");
  const installmentsSelect = form.find("#installments");
  const creditCardInstallments = form.find("#box-installments");
  const paymentMethodElements = form.find('[name="method"]');
  const creditCardForm = form.find("[data-show-on-creditcard]");
  const planTypeLabel = form.find("[data-show-plan-type]");
  const planNameLabel = form.find("[data-show-plan-name]");
  const corporateOnlyFields = form.find("[data-corporate-only]");
  const personalOnlyFields = form.find("[data-personal-only]");
  const internalPaymentMethodDivs = form.find(
      "[data-internal-payment-method-div]"
  );
  const externalPaymentMethodDivs = form.find(
      "[data-external-payment-method-div]"
  );
  var hotmartUrl = null;
  var memberRanges = null;
  var currentRange = null;
  //

  dbPlans = JSON.parse($("#raw-plan-data").html());
  couponObject = JSON.parse($("#raw-coupon-data").html());
  couponPlanIds = () => {
    if ((couponObject || {}).plans) {
      return couponObject.plans.map(plan => plan.id);
    } else {
      return [];
    }
  };

  const readablePlanType = type => {
    return {
      default: "Individual",
      corporate: "Grupo"
    }[type];
  };
  const getPlan = planId => dbPlans.find(({ id }) => planId == id);
  const planInput = planId => planInputs.filter("[value=" + planId + "]");
  const planTypeInput = planType =>
      planTypeInput.filter("[value=" + planType + "]");
  const currentPlanInput = () => planInputs.filter(":checked").first();
  const currentPlanTypeInput = () => {
    if (planTypeInputs.first().attr("type") === "radio") {
      return planTypeInputs.filter(":checked").first();
    } else {
      return planTypeInputs.first();
    }
  };
  //

  // Functions for better readability
  const numberToMoney = number => {
    if (number < 0) {
      number = 0;
    }

    return number_format(number, 2, ",", ".");
  };

  const currentPlanType = () => currentPlanTypeInput().val();
  const currentPlanId = () => currentPlanInput().val();
  const currentPlan = () => getPlan(currentPlanId());
  const numberOfMembers = () => memberCountInput.val() || 1;
  const numberOfInstallments = () => installmentsSelect.val();
  const couponData = () => couponObject || {};
  const currentPrice = () =>
      calculatePrice(
          currentPlan(),
          numberOfMembers(),
          numberOfInstallments(),
          couponData(),
          true
      );
  const currentOriginalPrice = () =>
      calculatePrice(
          currentPlan(),
          numberOfMembers(),
          numberOfInstallments(),
          couponData(),
          true,
          false
      );
  const currentUnitPrice = () => currentUnitMinorPrice();
  const currentFullPrice = () =>
      calculatePrice(currentPlan(), numberOfMembers(),1, {}, false, true);
  const percentageOf = (value, percentage) => value * (percentage / 100);
  //

  // Price Calculations and interface
  const generateDiscountObject = (plan, installments, coupon = {}) => {
    let discount = {};
    discount.one_installment_discount = (plan.one_installment_discount | 0) / 100;

    if (coupon.discount_type && coupon.discount_value) {
      discount.type = coupon.discount_type;
      discount.value = coupon.discount_value || 0;
    } else {
      discount.type = plan.discount_type;
      discount.value = plan.discount_value || 0;
    }

    if (installments > 1) {
      discount.one_installment_discount = 0;
    }

    return discount;
  };

  // const discountedPrice = (price, discount, changeOriginal = false) => {
  //   let final = price;

  //   if (discount.type === "amount") {
  //     final = final - discount.value * numberOfMembers();
  //   }else{
  //     final = final - percentageOf(final, discount.value / 100);
  //   }

  //   if (changeOriginal === false) {
  //     // One installment discount already comes divided by 100
  //     final = final - percentageOf(price, discount.one_installment_discount);
  //   }

  //   return final;
  // };

  const discountedPrice = (price, discount, numberOfMembers = 1) => {
    let finalPrice = price;

    if (discount.type === 'amount') {
        finalPrice -= discount.value * numberOfMembers;
    } else if (discount.type === 'percentage') {
        finalPrice -= price * (discount.value / 100);
    }

    return finalPrice;
};

const calculatePrice = (
  plan,
  members,
  installments = 1,
  coupon = {},
  applyDiscounts = false,
  changeOriginal = false,
  applyOneInstallmentDiscount = false
) => {
  if (!plan) {
      return 0;
  }

  const { price, discount_type, discount_value } = plan;

  let value = price;

    if (couponPlanIds().indexOf(plan.id) === -1) {
      coupon = {};
    }

  if (applyDiscounts) {
    if (discount_type && discount_value) {
      if (discount_type === 'amount') {
        value = price - discount_value;
      } else if (discount_type === 'percentage') {
        value = price - (price * (discount_value / 100)) / 100;
      } else {
        value = price;
      }
    }
  
    if (installments === 1 && applyOneInstallmentDiscount) {
      value -= (price * (plan.one_installment_discount / 100)) / 100;
    }
  
    if (coupon && coupon.discount_type && coupon.discount_value) {
      if (coupon.discount_type === 'amount') {
        value -= coupon.discount_value;
      } else if (coupon.discount_type === 'percentage') {
        value -= (price * (coupon.discount_value / 100)) / 100;
      }
    }
  
    if (value <= 0) {
      value = 0;
    }
  }

  return value;
};

  const updatePriceLabels = (planId, revert) => {
    const plan = currentPlan();
    let maxInstallments = 0;

    if (plan.max_installments > 0) {
      maxInstallments = plan.max_installments;
    }

    let value = calculatePrice(
        currentPlan(),
        numberOfMembers(),
        1,
        couponData(),
        true,
        false,
        false
    ) / 1;

    currentUnitPriceElements.html(
        "R$ " + numberToMoney(currentUnitPrice() / 100)
    );
    currentUnitPriceElements.val(
        "R$ " + numberToMoney(currentUnitPrice() / 100)
    );
    currentPriceElements.html("R$ " + numberToMoney(currentOriginalPrice() / 100));
    currentPriceElements.val("R$ " + numberToMoney(currentOriginalPrice() / 100));
    let installmentsLabel = $('#price_' + plan.id + '');
    if (planId) {
      let newValue = currentOriginalPrice() / 100;

      if (revert) {
        JSON.parse(planId).forEach(function(value, i) {
          let newValue = $('#plan_id' + value + '').attr('data-original-value');
          let planNewLabel = $('#new_value_' + value + '');
          let resumeNewPrice = $('#resumeNewPrice');
          let indicator = planNewLabel.attr('data-indicator');
          planNewLabel.attr('data-new-value', numberToMoney(newValue));
          planNewLabel.text(indicator + ' R$ ' + numberToMoney(newValue));
          resumeNewPrice.text(' R$ ' + numberToMoney(newValue));
        });

        let installmentsValue = $('#price_' + plan.id + '').attr('data-original-value');

        if (maxInstallments > 0) {
          let installments = installmentsValue/100;
          if (installments > 0) {
            installmentsLabel.text('R$ ' + numberToMoney(installments));
          }
        }

      }else {

        if (maxInstallments > 0) {
          let installments = ((value/100) / maxInstallments);
          if (installments > 0) {
            installmentsLabel.text('R$ ' + numberToMoney(installments));
          }
        }

        let planOldLabel = $('#old_value_' + plan.id + '');
        let planOldValue = planOldLabel.attr('data-old-value');
        let planNewValue = value/100;
        if (planOldValue > planNewValue) {
          planOldLabel.show();
        }

        let planNewLabel = $('#new_value_' + planId + '');
        let indicator = planNewLabel.attr('data-indicator');
        planNewLabel.attr('data-new-value', numberToMoney(planNewValue));
        planNewLabel.text(indicator + ' R$ ' + numberToMoney(planNewValue));

      }
    }

    if (currentPrice() != currentFullPrice()) {
      currentFullPriceElements.html(
          "R$ " + numberToMoney(currentFullPrice() / 100)
      );
      currentFullPriceElements.val(
          "R$ " + numberToMoney(currentFullPrice() / 100)
      );
    } else {
      currentFullPriceElements.html("");
      currentFullPriceElements.val("");
    }
  };

  const renderInstallmentsSelector = () => {
    const plan = currentPlan();

    if (!plan) {
      return;
    }

    let options = [];
    let oneInstallmentDiscount = plan.one_installment_discount;
    let currentInstallment = numberOfInstallments();
    for (let i = 1; i <= (plan.max_installments || 1); i++) {
      let price =
          calculatePrice(
              currentPlan(),
              numberOfMembers(),
              i,
              couponData(),
              true,
              true,
              true
          ) / i;

      let label = `${i}x de R$ ${numberToMoney(price / 100)}`;
      if (i === 1 && oneInstallmentDiscount / 100 > 0) {
        label = `${label} (${(oneInstallmentDiscount | 0) / 100}% de desconto)`;
      }

      options.push(
          `<option value="${i}" ${
              currentInstallment === i ? "selected" : ""
          }>${label}</option>`
      );
    }
    installmentsSelect.html(options.join(""));
    if(plan.max_installments == 1){
      creditCardInstallments.hide()
      creditCardInstallments.removeClass('d-flex')
    }
  };
  //

  const checkInput = $input => {
    if ($input.attr("type") === "radio") {
      uncheckGroup($input);
    }

    $input.prop("checked", true);
    $input.parents(radioHolderSelector).addClass("active");
  };

  const uncheckGroup = $input => {
    const group = form.find('[name="' + $input.attr("name") + '"]');

    group.prop("checked", false);
    group.parents(radioHolderSelector).removeClass("active");
  };

  const updateMaxMemberLabel = plan => {
    maxMemberLabelElements.html(plan.max_members);
  };

  const updatePlanLabels = (plan, members) => {
    if (!plan) {
      return;
    }
    planNameLabel.html(plan.title);
    planTypeLabel.html(
        readablePlanType(plan.type) +
        ` (${members} usuário${members > 1 ? "s" : ""})`
    );
  };

  const mountExternalUrl = plan => {
    var name = form.find('[name="name"]').val();
    var email = form.find('[name="email"]').val();
    var phone = form.find('[name="phone"]').val();
    var ddd = phone.match("(?<=...)..");
    var phone = phone.match("(?<=.....)\\d*");

    if (currentPlanType() == "default") {
      var doc = form.find('[name="document"]').val();
    } else {
      var doc = form.find('[name="company_document"]').val();
    }

    var hotmart_url =
        plan.external_checkout_url +
        "&name=" +
        name +
        "&email=" +
        email +
        "&phonenumber=" +
        phone +
        "&phoneac=" +
        ddd +
        "&doc=" +
        doc;
    return hotmart_url;
  };

  const renderExternalPaymentMethod = plan => {
    internalPaymentMethodDivs.addClass("d-none");
    externalPaymentMethodDivs.removeClass("d-none");

    internalPaymentMethodDivs.find("input").prop("required", false);
    hotmartUrl = mountExternalUrl(plan);
  };

  const renderBilletPaymentMethod = plan => {
    const bankSlipInput = paymentMethodElements.filter("[value=bank_slip]");
    const bankSlipInputHolder = bankSlipInput.closest(radioHolderSelector);

    if (plan.allow_bank_slip) {
      bankSlipInputHolder.show();
      bankSlipInputHolder.addClass("d-flex");
    } else {
      bankSlipInputHolder.hide();
      bankSlipInputHolder.removeClass("d-flex");
    }
  };

  const renderPixPaymentMethod = plan => {
    const pixInput = paymentMethodElements.filter("[value=pix]");
    const pixInputHolder = pixInput.closest(radioHolderSelector);

    if (plan.allow_pix) {
      pixInputHolder.show();
      pixInputHolder.addClass("d-flex");
    } else {
      pixInputHolder.hide();
      pixInputHolder.removeClass("d-flex");
    }
  };

  const renderPaypalPaymentMethod = plan => {
    const offsiteInput = paymentMethodElements.filter("[value=offsite]");
    const offsiteInputHolder = offsiteInput.closest(radioHolderSelector);

    // Generally this means paypal
    if (plan.allow_offsite) {
      offsiteInputHolder.show();
      offsiteInputHolder.addClass("d-flex");
    } else {
      offsiteInputHolder.hide();
      offsiteInputHolder.removeClass("d-flex");
    }
  };

  const addRequireToOriginallyRequiredInputsOnElement = element => {
    element.find("input, textarea, select").each((k, el) => {
      let input = $(el);
      if (input.data("originallyRequired")) {
        input.prop("required", true);
      }
    });
  };

  const removeRequiredToInputsOnElement = element => {
    element.find("input, textarea, select").prop("required", false);
  };

  const renderPlanMethods = plan => {
    if (plan.external_checkout_url != null) {
      // external checkout (mostly hotmart)
      renderExternalPaymentMethod(plan);
    } else {
      // standard checkout (mostly VINDI)
      hotmartUrl = null;
      externalPaymentMethodDivs.addClass("d-none");
      internalPaymentMethodDivs.removeClass("d-none");
      addRequireToOriginallyRequiredInputsOnElement(internalPaymentMethodDivs);
      removeRequiredToInputsOnElement(externalPaymentMethodDivs);

      renderBilletPaymentMethod(plan);
      renderPixPaymentMethod(plan);
      renderPaypalPaymentMethod(plan);

      checkInput(paymentMethodElements.filter("[value=credit_card]"));
      showCreditCardFormOnCreditCard();
    }
  };

  const changePlanTo = planId => {
    const plan = getPlan(planId);

    checkInput(planInput(planId));

    if (plan.type === "corporate") {
      updateMaxMemberLabel(plan);
      setNumberOfMembers(currentRange);
      //adaptSliderToPlan(plan);
    } else {
      setNumberOfMembers(1);
    }

    updatePriceLabels();
    updatePlanLabels(plan, numberOfMembers());
    renderPlanMethods(plan);
    renderInstallmentsSelector();
  };

  const setNumberOfMembers = number => {
    const label = `${number > 1 ? "Até" : ""} ${number} usuário${
        number > 1 ? "s" : ""
    }`;
    memberCountLabelElement.val(label);
    memberCountLabelElement.html(label);
    memberCountInput.val(number);
    updatePriceLabels();
    updatePlanLabels(currentPlan(), number);
    renderInstallmentsSelector();
  };

  const adaptSliderToPlan = plan => {
    if (plan.type != "corporate") {
      console.error("You should only adapt slider on corporate plans");
      return;
    }

    setNumberOfMembers(plan.min_members);
    const onChange = (event, { value }) => setNumberOfMembers(value);

    sliderElement.slider({
      min: plan.min_members,
      max: plan.max_members,
      value: plan.min_members,
      change: onChange,
      slide: onChange
    });
  };

  const onChangePlanType = () => {
    const type = currentPlanType();
    showOnlyPlansOfType(type);
    renderPlanTypeSpecificFields();

    if (type === "corporate") {
      showPlansByRange(currentRange);
      $("#n-members-readonly").html("Até " + currentRange + " usuários");
      memberSliderHolder.show();
    } else {
      memberSliderHolder.hide();
    }
  };

  const showCreditCardFormOnCreditCard = () => {
    if (paymentMethodElements.filter(":checked").val() === "credit_card") {
      creditCardForm.addClass("d-flex").show();
      addRequireToOriginallyRequiredInputsOnElement(creditCardForm);
    } else {
      creditCardForm.removeClass("d-flex").hide();
      removeRequiredToInputsOnElement(creditCardForm);
    }
    var plan = currentPlan();

    if (!plan) {
      return;
    }

    if(plan.max_installments == 1){
      creditCardInstallments.hide()
      creditCardInstallments.removeClass('d-flex')
    }
  };

  const renderPlanTypeSpecificFields = () => {
    const filterByType = type => (k, el) => {
      if (currentPlanType() === type) {
        $(el).show();
        addRequireToOriginallyRequiredInputsOnElement($(el));
      } else {
        $(el).hide();
        removeRequiredToInputsOnElement($(el));
      }
    };
    corporateOnlyFields.each(filterByType("corporate"));
    personalOnlyFields.each(filterByType("default"));
  };

  const removeRequiredFromInvisibleInputs = () => {
    form.find("input:not(:visible), select:not(:visible)").each((k, el) => {
      $(el).prop("required", false);
    });
  };

  /**
   * Used to verify if all of the inputs
   * and labels were created and found on the DOM.
   */
  const verifyForm = () => {
    const selectors = {
      form,
      planTypeInputs,
      planInputs,
      oldPriceContainer,
      newPriceContainer,
      memberSliderHolder,
      memberCountInput,
      sliderElement,
      memberCountLabelElement,
      maxMemberLabelElements,
      currentPriceElements,
      currentFullPriceElements,
      installmentsSelect,
      paymentMethodElements,
      creditCardForm,
      planTypeLabel,
      planNameLabel,
      corporateOnlyFields
    };

    for (var varName in selectors) {
      if (!selectors[varName].length) {
        console.warn(
            `"${varName}" wasn't found on the form, this may affect the checkout form functionality`
        );
      }
    }
  };

  const showOnlyPlansOfType = planType => {
    const filteredPlans = dbPlans.filter(plan => plan.type == planType);
    const ids = filteredPlans.map(plan => plan.id);

    const inputs = planInputs.filter((k, el) => {
      return ids.indexOf($(el).val() | 0) > -1;
    });

    planInputs.parents(radioHolderSelector).hide();
    inputs.parents(radioHolderSelector).show();
    changePlanTo(ids[0]);
  };

  const showPlansByRange = currentRange => {
    const type = currentPlanType();
    const filteredPlans = dbPlans.filter(
        plan => plan.max_members == currentRange && plan.type == type
    );

    const ids = filteredPlans.map(plan => plan.id);

    const inputs = planInputs.filter((k, el) => {
      return ids.indexOf($(el).val() | 0) > -1;
    });

    planInputs.parents(radioHolderSelector).hide();
    inputs.parents(radioHolderSelector).show();
    changePlanTo(ids[0]);
  };

  var currentUnitMinorPrice = () => {
    const type = currentPlanType();
    const filteredPlans = dbPlans.filter(
        plan => plan.max_members == currentRange && plan.type == type
    );

    const prices = filteredPlans.map(
        plan =>
            calculatePrice(
                plan,
                numberOfMembers(),
                numberOfInstallments(),
                couponData(),
                true
            ) / numberOfMembers()
    );

    return Math.min(...prices);
  };

  const setupSlider = () => {
    var ranges = [];
    $("#plans_max_ranges option").each(function () {
      ranges.push($(this).val());
    });
    memberRanges = ranges;

    currentRange = memberRanges[0];
    if (currentPlanType() == "corporate") {
      showPlansByRange(currentRange);
    }
    var slider = $('<div id="slider"></div>')
        .insertAfter($("#plans_max_ranges"))
        .slider({
          min: 0,
          max: Number(ranges.length - 1),
          value: 0,
          step: 1,
          slide: function (event, ui) {
            $("#n-members-readonly").html(
                "Até " + ranges[ui.value] + " usuários"
            );
            currentRange = ranges[ui.value];
            showPlansByRange(currentRange);
          }
        });
    $("#n-members-readonly").html(
        "Até " + ranges[$("#slider").slider("value")] + " usuários"
    );
  };

  const initForm = () => {
    verifyForm();
    $("input[checked][type=radio]").each((k, input) => checkInput($(input)));
    $("input[type=radio]").click(e => checkInput($(e.target)));
    planInputs.change(e => changePlanTo($(e.target).val()));
    planTypeInputs.change(onChangePlanType);
    installmentsSelect.change(updatePriceLabels);
    paymentMethodElements.change(showCreditCardFormOnCreditCard);
    form
        .find("input")
        .each((k, el) =>
            $(el).data("originallyRequired", $(el).prop("required"))
        );

    onChangePlanType();
    showCreditCardFormOnCreditCard();
    setupSlider();
  };

  const notifyCouponUsageResponse = (message, type) => {
    new Noty({
      text: message,
      type: type
    }).show();
  };

  const refreshCouponDiscounts = () => {
    const planInputs = $('input[name=plan_id]');
    const selectedPlanInput = $('input[name=plan_id]:checked');

    const selectedPlanId = selectedPlanInput.val();
    const couponPlans = couponPlanIds();

    couponPlans.map(function (plan, i) {
      refreshPlanPriceLabel(plan);
    });

    refreshPlanPriceLabel(selectedPlanId);

    planInputs.map(function (i, input) {
      var input = $(input);
      var planPrice = input.attr('data-plan-price');
      var planId = parseInt(input.val());

      if (!couponPlans.includes(planId)) {
        let planOldPriceDiv = $('div[data-plan-id="' + planId + '"]').find('div.old');
        let planNewPriceDiv = $('div[data-plan-id="' + planId + '"]').find('div.new');
        planNewPriceDiv.html('<span class="price">R$ ' + (planPrice / 100).toFixed(2).replace('.', ',') + '</span>');
        planOldPriceDiv.html('');
      }
    });
  };

  const refreshPlanPriceLabel = (planId) => {
    let planPricing = $('div[data-plan-id="' + planId + '"]');
    let planOldPriceDiv = planPricing.find('div.old');
    let planNewPriceDiv = planPricing.find('div.new');
    let resumeOldPriceDiv = $('#resumeOldPrice');
    let resumeNewPriceDiv = $('#resumeNewPrice');

    let planOldPrice = planOldPriceDiv.text().replace('R$', '').replace(',', '.').trim();
    let planNewPrice = planNewPriceDiv.text().replace('R$', '').replace(',', '.').trim();

    if (planOldPrice === "") {
      planOldPrice = planNewPrice;
    }

    if (couponObject.discount_type === 'percentage') {
      planNewPrice = (parseFloat(planNewPrice) * (1 - (couponObject.discount_value / 10000))).toFixed(2);
    } else if (couponObject.discount_type === 'amount') {
      planNewPrice = (parseFloat(planNewPrice) - (couponObject.discount_value / 100)).toFixed(2);
    }

    planNewPriceDiv.html('<span class="price">R$ ' + planNewPrice.replace('.', ',') + '</span>');
    planOldPriceDiv.html('<span class="price">R$ ' + planOldPrice.replace('.', ',') + '</span>');
    resumeNewPriceDiv.text('R$ ' + planNewPrice.replace('.', ','));
    resumeOldPriceDiv.text('R$ ' + planOldPrice.replace('.', ','));

  };

  const getCouponRequestData = () => {
    let form = $('#formCoupon');
    let method = form.attr('method');

    let action = form.attr('action');
    let token = form.find('input[name="_token"]').val();
    let coupon = form.find('input[name="coupon_code"]').val();
    let deleteRoute = form.attr('data-delete-route');

    return {
      action: action,
      method: method,
      token: token,
      coupon: coupon,
      deleteRoute: deleteRoute
    };
  };

  const addCoupon = () => {
    const button = $('#submitCoupon');
    let data = getCouponRequestData();
    let planId = currentPlanInput();

    $.ajax({
      url: data.action,
      method: data.method,
      data: { _token: data.token, coupon_code: data.coupon, plan_id: planId.val() },
      beforeSend: function () {
        button.attr('disabled', true);
        button.text('Ativando...');
      }
    })

        .done(function (response) {
          $("#raw-coupon-data").html(JSON.stringify(response.coupon));
          couponObject = response.coupon;
          renderInstallmentsSelector();
          refreshCouponDiscounts();
          updatePriceLabels(planId.val());
          notifyCouponUsageResponse(response.message, 'success');
          let htmlForm = response.html;
          if (htmlForm) {

            $('#coupon-form').html(atob(htmlForm));

            let element = document.getElementById("deleteCoupon");
            element.addEventListener("click", function(e) {

              let button = $(element.outerHTML);
              let plans = button.attr('data-plans');
              let couponId = button.attr('data-coupon-id');

              delCoupon(false, plans, couponId, button);
            });
          }
        })

        .fail(function (response) {
          notifyCouponUsageResponse(response.responseJSON.message, 'error');
        })

        .always(function () {

          button.attr('disabled', false);
          button.text('Ativar');
        });
  };

  const delCoupon = (button, plans, coupon, object) => {
    let localPlans = [];
    let data = getCouponRequestData();

    if (button) {
      localPlans = button.attr('data-plans');
      data.coupon = button.attr('data-coupon-id');
    }else{
      localPlans = plans;
      data.coupon = coupon;
    }

    $.ajax({
      url: data.deleteRoute,
      method: 'DELETE',
      data: { _token: data.token, coupon_code: data.coupon },
      beforeSend: function () {
        if (button) {
          button.attr('disabled', true);
        }else{
          $('#deleteCoupon').attr('disabled', true);
        }
      }
    })

        .done(function (response) {
          $("#raw-coupon-data").remove();
          renderInstallmentsSelector();
          refreshCouponDiscounts();
          updatePriceLabels(localPlans, true);
          notifyCouponUsageResponse(response.message, 'success');
          if (button) {
            button.parent().remove();
          }else{
            $('#deleteCoupon').parent().remove();
          }

        })

        .fail(function (response) {
          notifyCouponUsageResponse(response.responseJSON.message, 'error');
        })

        .always(function () {
          if (button) {
            button.parent().remove();
          }else{
           $('#deleteCoupon').parent().remove();
          }
          location.reload();
        });
  };

  $('#submitCoupon').on('click', function (e) {
    e.preventDefault();
    addCoupon();
  });

  $('#deleteCoupon').on('click', function(e){
    e.preventDefault();
    delCoupon($(this));
  });

  initForm();
  window.removeRequiredFromInvisibleInputs = removeRequiredFromInvisibleInputs;

  $(".data-checkout-form").on("submit", function (e) {
    if (hotmartUrl != null) {
      e.preventDefault();
      hotmartUrl = mountExternalUrl(currentPlan());
      window.location = hotmartUrl;
      return false;
    } else {
      return true;
    }
  });

  //SHIT THAT MUST BE TRANSFER TO THE CSS
  $(".ui-slider-handle").css("margin-left", "-8px");
  if ($("header").width() >= 450) {
    // is mobile device
    $(".ui-slider").css("margin", "0px");
  }
  $(".ui-slider").css("border-radius", "5px");
  $("#n-members-readonly").css("font-size", "16px");
};

$(initCheckout());
